module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nvar buttonMode = (model.config || {}).relationName || 'client';\nvar prefix = '';\nif(model.addressID && storage.user && storage.user.hasRoleOption('showIDs', 'art_crm')){\nprefix = '# ' + model.addressID + ' - ';\n}\nvar title = '';\nif(model.title){\ntitle = model.title;\n} else {\nadditionalClasses.push('unspecified');\ntitle = storage.__('dataValues.options.unspecified');\n}\n%>\n<div class=\"<%- additionalClasses.join(' '); %>\" data-field-code=\"<%- model.fieldCode || '' %>\">\n<div><%= prefix + title %></div>\n<section class=\"buttons\">\n<%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'address', mode: buttonMode, symbolOnly: true } }); %>\n<%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'address', mode: buttonMode, symbolOnly: true } }); %>\n</section>\n</div>"
  , __filename = "components/templates/artCrm/trip/fields/addressSelector.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
var buttonMode = (model.config || {}).relationName || 'client';
var prefix = '';
if(model.addressID && storage.user && storage.user.hasRoleOption('showIDs', 'art_crm')){
prefix = '# ' + model.addressID + ' - ';
}
var title = '';
if(model.title){
title = model.title;
} else {
additionalClasses.push('unspecified');
title = storage.__('dataValues.options.unspecified');
}

    ; __line = 15
    ; __append("\n<div class=\"")
    ; __line = 16
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode || '' )
    ; __append("\">\n<div>")
    ; __line = 17
    ; __append(escapeFn( prefix + title ))
    ; __append("</div>\n<section class=\"buttons\">\n")
    ; __line = 19
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'address', mode: buttonMode, symbolOnly: true } }) )
    ; __append("\n")
    ; __line = 20
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'address', mode: buttonMode, symbolOnly: true } }) )
    ; __append("\n</section>\n</div>")
    ; __line = 22
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/artCrm/trip/fields/addressSelector.ejs

}